// hooks/useSensorMeasurements.js - Fixed to handle API response structure
import { useApi } from './useApi';
import { sensorService } from '../services/sensorService';

export function useSensorMeasurements(boxId, sensorId, params = {}) {
  console.log('DEBUG: useSensorMeasurements called for:', { boxId, sensorId, params });

  const { data, loading, error, retry, refetch } = useApi(
    async () => {
      console.log('DEBUG: useApi callback executing sensorService.getSensorMeasurements');
      const response = await sensorService.getSensorMeasurements(boxId, sensorId, params);

      // Handle the response structure: {measurements: Array, max_id: number}
      if (response && response.measurements) {
        console.log('DEBUG: Extracted measurements array:', {
          length: response.measurements.length,
          maxId: response.max_id
        });
        return response.measurements;
      }

      // If it's already an array, return it directly
      if (Array.isArray(response)) {
        console.log('DEBUG: Response is already an array:', response.length);
        return response;
      }

      console.warn('DEBUG: Unexpected response format:', response);
      return [];
    },
    [boxId, sensorId, JSON.stringify(params)]
  );

  // Determine the type of measurements data
  const measurementsType = data ? (Array.isArray(data) ? 'array' : typeof data) : 'undefined';
  const measurementsIsArray = Array.isArray(data);

  console.log('DEBUG: useSensorMeasurements returning:', {
    hasData: !!data,
    dataLength: Array.isArray(data) ? data.length : 'N/A',
    loading,
    error: error?.message || null,
    measurementsType,
    measurementsIsArray
  });

  return {
    measurements: data || null,
    loading,
    error,
    retry,
    refetch,
    measurementsType,
    measurementsIsArray
  };
}